
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0258c3a1&scoped=true!stylus-loader?sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./download.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./download.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0258c3a1!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./download.vue"),
  /* scopeId */
  "data-v-0258c3a1",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/common/download/download.vue
// module id = 2
// module chunks = 1